import Image from 'next/image';

import { Text } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';

const NoItemFound = () => (
  <div
    className={`flex flex-col lg:flex-row items-center justify-center bg-white border border-gray-200 rounded-lg my-5 p-6 space-y-6 lg:space-y-0 lg:space-x-8 shadow-sm`}
  >
    <div className='w-60 h-60 relative'>
      <Image
        alt='No Celebrations'
        layout='fill'
        objectFit='contain'
        src={`${staticMediaStoreBaseURL}/default-images/empty-events.svg`}
      />
    </div>
    <div className='text-center lg:text-left'>
      <Text
        {...{
          className: 'md:text-2xl text-base text-brand',
          content: 'No celebrations planned yet!'
        }}
      />
      <Text
        {...{
          className: 'md:text-2xl text-base text-brand',
          content: 'Let’s get the party started!'
        }}
      />
    </div>
  </div>
);

export default NoItemFound;
